import { AppConsts } from "../../shared/app-consts";
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, switchMap, filter } from "rxjs/operators";
import { AuthenticationService } from "./Authentication.service";
import { LoaderService } from "../../modules/loader";
import { ErrorService } from '@modules/error/services/error.service';
import { ErrorModel } from '@modules/error/models/error.model';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private refreshing$ = new BehaviorSubject<boolean>(false);

  constructor(private authenticationService: AuthenticationService,
    private loaderService: LoaderService,
    private errorService: ErrorService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers = this.setHeaders(req);
    
    return next.handle(req.clone(headers)).pipe(
      catchError(err => {
        if (req.url.includes('login') || req.url.includes('refresh')) {
          if (req.url.includes('refresh')) this.authenticationService.logout();
          return throwError(err);
        }
        switch (err.status) {
          case 401: return this.handle401Error(req, next);
          case 500: return this.handle500Error(req, next);
          default: {
            this.loaderService.hideLoader();
            return throwError(err);
          }
        }
      })
    );
  }

  private setHeaders(req: HttpRequest<any>) {
    const token = JSON.parse(sessionStorage.getItem(AppConsts.TOKEN_KEY));
    if (token) {
      let headers = req.headers.set("ApplicationName", AppConsts.APPLICATION_NAME); 
      const cloned = req.clone({
        headers: headers
      });
      return cloned;
    }

    return req;
  }

  private handle401Error(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.refreshing$.getValue()) {
      this.refreshing$.next(true);
      this.authenticationService.refreshToken().subscribe((response) => {
        this.refreshing$.next(false);
        if (response == null) {
          this.loaderService.hideLoader();
          this.authenticationService.logout();
        }
      });
    }

    return this.refreshing$.pipe(filter(refreshing => refreshing == false), switchMap(() =>
      this.authenticationService.refreshToken() ? next.handle(req.clone(this.setHeaders(req)))
        :
        throwError(new Error('Not authorized'))
    ));
  }

  private handle500Error(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.hideLoader();
    this.errorService.addError(new ErrorModel('Une erreur applicative a été detecté lors du traitement de votre demande !'))
    return throwError(new Error('A server application error occured while processing your request !'));
  }
}
